// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1z9G6","colMin":"styles_colMin__2T7tk","colCheckbox":"styles_colCheckbox__irieg"};